import * as React from "react";
import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import { Add, ArrowBack } from "@mui/icons-material";
import Button from "@mui/material/Button";
import { translate } from "../../../../../translate/translate";
import { NpiProject } from "../types/npi-project.types";

interface NpiProjectHeaderProps {
    project: NpiProject;
    onBack: () => void;
}

const NpiProjectHeaderComponent: React.FC<NpiProjectHeaderProps> = ({ project, onBack }) => {
    return (
        <Box>
            <Grid container justifyContent="space-between" alignItems="center" sx={{pb: 2, pt: 2, pl: 2, pr: 2}}>
                <Grid sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <IconButton onClick={onBack} size="small">
                        <ArrowBack color="primary" />
                    </IconButton>
                    <Box>
                        <Typography variant="h6" fontWeight="bold">
                            {translate.t("project_planning")}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {translate.t("client")}: {project.client}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
            <Divider sx={{ borderColor: "#E2E8F0", borderBottomWidth: "2px", ml: "-15px", top: "-5px", position: "relative" }} />
        </Box>
    );
};

export default NpiProjectHeaderComponent;
